<template>
    <div class="pincode-form">
        <FieldPincode
            ref="pinInput"
            v-model="modelValue"
            :errorMsg="error"
            :groupLabel="groupLabel"
            darkColor
            @enter="emits('enter')"
        />
        <div class="pincode-form__bottom">
            <div v-if="countdown > 0" class="auth-form__timer" role="status" aria-live="polite">
                Отправить код повторно (через <span>{{ formattedTime }}</span>)
            </div>
            <button v-else type="button" class="link" @click="sendCode">Отправить код повторно</button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import FieldPincode from './FieldPincode.vue';

const props = defineProps({
    error: {
        type: String,
        default: ''
    },
    darkColor: {
        type: Boolean,
        default: false
    },
    groupLabel: {
        type: String,
        default: 'Код подтверждения'
    }
})

const PINCODE_LENGTH = 6;

const modelValue = defineModel<string>({required: true});
const countdown = ref<number>(60);
const timerInterval = ref<any>(null);

const pinInput = ref<InstanceType<typeof FieldPincode> | null>(null);

const formattedTime = computed(() => {
  return `${countdown.value} сек`;
})

const emits = defineEmits(['sendAgain', 'enter', 'complete']);

const completeEmitted = ref(false);

watch(modelValue, (value) => {
    if (value.length !== PINCODE_LENGTH) {
        // Код стёрли/поправили — снимаем флаг, иначе после неверного кода
        // повторный ввод уже не поднял бы `complete` и автовход не сработал бы.
        completeEmitted.value = false;
        return;
    }
    if (completeEmitted.value) {
        return;
    }
    completeEmitted.value = true;
    emits('complete');
});

const focusFirst = () => {
    pinInput.value?.focusFirst();
};

defineExpose({focusFirst});

const startCountdown = () => {
    stopCountdown();
    countdown.value = 60;
    timerInterval.value = setInterval(() => {
        if (countdown.value > 0) {
        countdown.value--;
        } else {
        stopCountdown();
        }
    }, 1000);
}
const stopCountdown = () => {
    clearInterval(timerInterval.value);
}
const sendCode = () => {
    emits('sendAgain');
    startCountdown();

    if (pinInput.value) {
        pinInput.value.clearValue();
    }
}
onMounted(() => {
    startCountdown();  
})
onBeforeUnmount(() => {
    stopCountdown();
})
</script>

<style lang="scss">
.pincode-form {
    &__bottom {
        margin-top: 8px;
        text-align: center;
        font-size: 12px;
        color: $color-text-subtle;
    }

    button.link {
        appearance: none;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: $color-accent-text;
        font-weight: 700;
        font-size: 14px;
        @include modal-text-link-states($purple-base: true);
    }
}
</style>
